<template>
<kanban
    :cols='cols'
    :data=data >
  <template slot="list" slot-scope="props" >
    <invoice-list
      class='invoice-list'
      :invoices='visibleItems[props.col.value]'
      :actions="actions"
      :loading="invoicesRequest.loading"
      v-on='events' >
    </invoice-list>
    <v-card flat
      v-if='items[props.col.value] && (items[props.col.value].length >= visibleItemCount)' >
      <v-card-actions >
        Showing {{ visibleItemCount }} of {{ items[props.col.value].length }}
        <v-btn
          @click='visibleItemCount += pageSize'
          flat text >Load more</v-btn>
      </v-card-actions>
    </v-card>
  </template>
</kanban>
</template>

<script>
import { LIST_INVOICES_IN_RANGE_REQ } from '@/store/constants'
import InvoiceList from '@/components/invoice/InvoiceList'
import Kanban from '@/components/invoice/layout/Kanban'

export default {
  name: 'ProgressKanban',
  components: {InvoiceList, Kanban},
  props: {
    data: { type: Array, default: () => { return {} } },
    actions: { type: Array, default: () => { return [] } },
    searchString: { type: String, required: false }
  },
  data () {
    return {
      visibleItemCount: 10,
      pageSize: 10,
      cols: [
        {
          text: 'In progress',
          value: 'new',
          summary: this.calculateTotal
        },
        {text: 'Sent', value: 'sent', summary: this.calculateTotal},
        {text: 'Paid', value: 'paid', summary: this.calculateTotal}
      ]
    }
  },
  methods: {
    calculateTotal (items) {
      let total = items.reduce((total, item) => {
        return parseFloat(item.invoice_amount) + total
      }, 0)
      if (total > 0) {
        let currency = items[0].currency
        return this.formatCurrency(currency, total)
      }
      return false
    },

    filteredItems (col) {
      let items = this.$store.getters.getInvoicesByStatus(col)
      if (this.searchString) {
        items = items.filter((item) => {
          let index = `${item.title} ${item.date} ${item.invoice_amount} ${item.id}`.toLowerCase()
          return index.indexOf(this.searchString.toLowerCase()) >= 0
        })
      }
      let visible = items.slice(0, this.visibleItemCount)
      return visible
    }
  },
  computed: {
    invoicesRequest () {
      return this.$store.getters.getRequestById(LIST_INVOICES_IN_RANGE_REQ, true)
    },
    totalItems () {
      return this.getObjectPath(this.invoicesRequest, 'result.data.count', 0)
    },
    allinvoices () {
      return this.getObjectPath(this.invoicesRequest, 'result.data.results', [])
    },
    items () {
      return {
        new: this.$store.getters.getInvoicesByStatus('new'),
        sent: this.$store.getters.getInvoicesByStatus('sent'),
        paid: this.$store.getters.getInvoicesByStatus('paid')
      }
    },
    visibleItems () {
      // let items = this.$store.getters.getInvoicesByStatus(lookup)
      return {
        new: this.filteredItems('new'),
        sent: this.filteredItems('sent'),
        paid: this.filteredItems('paid')
      }
    },
    events () {
      let vm = this
      let events = {
        'primarycta': (invoice) => { vm.$emit('primarycta', invoice) }
      }
      this.actions.forEach((action) => {
        events[action.action] = (invoice) => {
          vm.$emit(action.action, invoice)
        }
      })
      return events
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ProgressKanban.vue?c4df7ab4